export function emptyStaticContentDetail(lang) {
  return {
    lang,
    body: '',
  };
}

export function mergeStaticContentWithLanguages(languages, existingRecords = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingRecords || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingRecords || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyStaticContentDetail(code), _label: label };
  });
}

export function hasStaticContentBody(detail) {
  return Boolean(detail?.body?.trim());
}
